import { useCallback, useState } from 'react';
import { Button, Grid } from '@mui/material';
import { useAppDispatch } from 'redux-store/hooks/useAppDispatch';
import { HashtagMentionTypeEnum } from 'redux-store/api/activity-feed/hashtags.types';
import { styles } from './styles';
import { urlRegex } from 'utils/constants';
import { setHashtagMetadata } from 'redux-store/slices/hashtag-slice';
import { createHashtagPayload } from 'utils/mappers';

export const DraftCardMessage = ({
  message,
  projectId,
}: {
  message: string;
  projectId: number;
}) => {
  const dispatch = useAppDispatch();

  const [isOverflowing, setIsOverflowing] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const handleRef = useCallback((node: HTMLDivElement | null) => {
    if (node) {
      const isOverflown = node.scrollHeight > node.clientHeight;
      setIsOverflowing(isOverflown);
    }
  }, []);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target as HTMLElement;

    const hashtagEl = target.closest('[data-mention-type="hashtag"]') as HTMLElement | null;

    if (hashtagEl) {
      const hashtagType = hashtagEl.getAttribute('data-hashtag-type') as HashtagMentionTypeEnum;
      const hashtagId = hashtagEl.getAttribute('data-hashtag-id');
      const mimeType = hashtagEl.getAttribute('data-mimetype');

      const payload = createHashtagPayload({
        type: hashtagType,
        id: Number(hashtagId),
        mimeType,
        projectId,
      });

      dispatch(setHashtagMetadata(payload));

      e.stopPropagation();
      return;
    }
  };

  return (
    <Grid>
      <Grid
        ref={handleRef}
        sx={styles.typo(expanded)}
        component="div"
        dangerouslySetInnerHTML={{
          __html: message.replace(urlRegex, (url) => {
            return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
          }),
        }}
        onClick={handleClick}
      />
      {isOverflowing && (
        <Button sx={styles.button} onClick={() => setExpanded((prev) => !prev)}>
          {expanded ? 'Show less' : 'Show more'}
        </Button>
      )}
    </Grid>
  );
};
